/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { SaveSBPB2CDriverBankMutationRequest, SaveSBPB2CDriverBankMutationResponse, SaveSBPB2CDriverBank400, SaveSBPB2CDriverBank401, SaveSBPB2CDriverBank403, SaveSBPB2CDriverBank500, SaveSBPB2CDriverBank503 } from "../entities/SaveSBPB2CDriverBank";

function getSaveSBPB2CDriverBankUrl() {
  const res = { method: 'POST', url: `/api/v1/payouts/sbp-b2c/bank` as const }
  return res
}

/**
 * @description Сохраняет выбранный водителем банк СБП, телефон получателя и email для месячных чеков СМЗ (необязательный).
 * Сохранённый банк становится текущим: на него уходят следующие выплаты
 * (`POST /api/v1/payouts/sbp-b2c`). Прежние выборы остаются в истории.
 * **Требования:**
 * - JWT access-токен водителя (`Authorization: Bearer`) и заголовки `user-id`, `city-id`
 * - `user-id` должен совпадать с пользователем из токена, иначе `403`
 * Телефон и email хранятся только в зашифрованном виде.
 * @summary Сохранение банка СБП водителя
 * {@link /api/v1/payouts/sbp-b2c/bank}
 */
export async function saveSBPB2CDriverBank(data: SaveSBPB2CDriverBankMutationRequest, config: Partial<RequestConfig<SaveSBPB2CDriverBankMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SaveSBPB2CDriverBankMutationResponse, ResponseErrorConfig<SaveSBPB2CDriverBank400 | SaveSBPB2CDriverBank401 | SaveSBPB2CDriverBank403 | SaveSBPB2CDriverBank500 | SaveSBPB2CDriverBank503>, SaveSBPB2CDriverBankMutationRequest>({ method : "POST", url : getSaveSBPB2CDriverBankUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}